var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPadlockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4167 1.04167C9.26607 1.04167 8.33333 1.97441 8.33333 3.125V7.29167C9.48393 7.29167 10.4167 8.22441 10.4167 9.375V14.5833C10.4167 15.7339 9.48393 16.6667 8.33333 16.6667H2.08333C0.93274 16.6667 0 15.7339 0 14.5833V9.375C0 8.22441 0.93274 7.29167 2.08333 7.29167H7.29167V3.125C7.29167 1.39911 8.69078 0 10.4167 0C12.1426 0 13.5417 1.39911 13.5417 3.125V7.29167C13.5417 7.57931 13.3085 7.8125 13.0208 7.8125C12.7332 7.8125 12.5 7.57931 12.5 7.29167V3.125C12.5 1.97441 11.5673 1.04167 10.4167 1.04167Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPadlockOpen);
export default __webpack_public_path__ + "static/media/ico-padlock-open.dd1569cd8a6abb0d468830e63376cfad.svg";
export { ForwardRef as ReactComponent };